
import { Component, OnInit, Input, ElementRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormControl,} from "@angular/forms";
import { Router } from "@angular/router";
import { Components } from "@ionic/core";
import { ReportsService } from "../reports/reports.service";
import { environment } from "../../environments/environment";
import * as moment from "moment";
import { AgenciesService } from "../agencies/agencies.service";
//import { saveAs } from 'file-saver';
import { DatePipe } from "@angular/common";
import { ModalController, NavParams, ToastController } from "@ionic/angular";
import { AwardsService } from "../awards/awards.service";
import { SchoolsService } from "../schools/schools.service";
import { ThrowStmt } from "@angular/compiler";
import { ElementArrayFinder } from "protractor";
import { elementEventFullName } from "@angular/compiler/src/view_compiler/view_compiler";
import { FundingService } from "../funding/funding.service";
import { CalendarService } from "./../core/services/calendar.service";
import { GlobalShareService } from "../core/services/global-share.service";
import { DatepickerDateCustomClasses } from "ngx-bootstrap/datepicker";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { ChangeDetectorRef } from "@angular/core";
import { UserProfileStorageService } from '../services/user-profile-storage.service';

@Component({
  selector: "generate-reports",
  templateUrl: "./generate-reports.component.html",
  styleUrls: ["./generate-reports.component.scss"],
})
export class GenerateReportsComponent implements OnInit {
  public reportForm: FormGroup;
  loading = false;
  @Input() create;
  //yearList = new Date().getFullYear();
  Reports: any;
  @Input() modal: Components.IonModal;
  isConfirm = false;
  @Input() isCancel;
  showRadioOption = true;
  blob: any;
  reportS3url: any;
  generateReportText: any = "Generate Report";
  generatedReportName: any;
  report: any;
  agenciesList: any = [];
  yearOpt: any = 0;
  agencyId: any = -1;
  awardsList: any = [];
  funderList: any = [];
  schoolsList: any = [];
  absenceRosterStudentSelection:String="all";
  enrichmentCodesList: any = [];
  calendarYearList: any = [];
  activitiesList: any = [];
  reportName: any;
  showAgency: boolean;
  showFYCYOpt: boolean;
  showSchools: boolean;
  showYear: boolean;
  showMCYear: boolean;
  expandFYDP: boolean;
  showCYYear: boolean;
  showAnnualOutcome: boolean;
  fiscalYearList: any[];
  masterCalendarList: any[];
  tempActivitiesList: any[];
  showStart: boolean;
  showAwards: boolean;
  showEnd: boolean;
  hideAgency: boolean = true;
  disableGenerate = false;
  disableStartEnd = true;
  disableSchools = false;
  disableAgency = false;
  disableEnrichmentCodes = false;
  disableActivities = false;
  showEnrichmentCodes: boolean;
  disableAwards = false;
  multipleAgencies = false;
  multipleActivities = true;
  start: any = null;
  displayMultipleSelection: boolean = false;
  displayMultipleSchoolSelection: boolean = false;
  isSchoolsListUpdated: boolean = false;
  isSelectedMCCChanged: boolean = false;
  // minDate: Date = null;
  // maxDate: Date = null;

  startMinDate: Date = null;
  startMaxDate: Date = new Date();

  endMinDate: Date = null;
  endMaxDate: Date = null;

  allDates: any = [];
  enabledDates: any = [];
  highlightOnlyReportDates: DatepickerDateCustomClasses[] = [];
  end: any = null;
  fyear: any;
  reportstatus: any;
  selectedAgencyId: any = -1;
  selectedMCC: any;
  selectAgencyFormControl = new FormControl();
  searchAgencyInputTxt = new FormControl();
  selectedAgency = [];
  filteredAgencyOptions: Observable<any[]>;

  selectSchoolFormControl = new FormControl();
  searchSchoolInputTxt = new FormControl();
  selectedSchool = [];
  filteredSchoolOptions: Observable<any[]>;
  filteredSchoolOptions2 = [];
  SelectedfilteredSchoolOptions = [];
  selectedAgencyIds: any;
  selectedSchoolIds: any;
  reportMsg = "";
  availableDate: any = [];

  @ViewChild("searchAgency", { static: false }) searchAgencyTextBox: ElementRef;
  @ViewChild("searchSchool", { static: false }) searchSchoolTextBox: ElementRef;
  newControlName = 'schoolmultilist';
  dropDownSelect = false;
  limitScheduledGroups = false;

  @ViewChild("multiSelect", { static: false }) multiSelect;
  public loadContent: boolean = false;
  public data = [];
  public settings = {};
  public selectedItems = [];

  // s3reports:Array<any> = [];
  constructor(public router: Router,
    public formBuilder: FormBuilder,
    private reportService: ReportsService,
    public agenciesService: AgenciesService,
    public awardsService: AwardsService,
    public schoolsService: SchoolsService,
    public fundingService: FundingService,
    public calendarService: CalendarService,
    public toastController: ToastController,
    private globalShareService: GlobalShareService,
    private cdr: ChangeDetectorRef,
    private userProfileStorage: UserProfileStorageService
  ) {
    this.reportForm = formBuilder.group({
      agencies: [[], [Validators.required]],
      startDate: ["", [Validators.required]],
      endDate: ["", [Validators.required]],
      masterCalendarId: ["0", Validators.required],
      fiscalYearId: [0, Validators.required],
      schoolmultilist:[[], [Validators.required]]
    });
  }

  private _agencyFilter(name: string): String[] {
    const filterValue = name.toLowerCase();
    this.setAgencySelectedValues();
    this.selectAgencyFormControl.patchValue(this.selectedAgency);
    let filteredList = this.agenciesList.filter((option) => option.name.toLowerCase().indexOf(filterValue) === 0);
    filteredList.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
    var allAgencies = "All Agencies";
    filteredList.unshift(
      filteredList.splice(
        filteredList.findIndex((item) => item.name === allAgencies),
        1
      )[0]
    );
    return filteredList;
  }

  private _schoolFilter(name: string): String[] {
    const filterValue = name.toLowerCase();
    this.setSchoolSelectedValues();
    this.selectSchoolFormControl.patchValue(this.selectedSchool);
    let filteredList = this.schoolsList.filter((option) => option.schoolName.toLowerCase().indexOf(filterValue) === 0);
    filteredList.sort((a, b) => a.schoolName.toLowerCase() > b.schoolName.toLowerCase() ? 1 : -1);
    // var allschools = "All Schools";
    // filteredList.unshift(filteredList.splice(filteredList.findIndex((item) => item.schoolName === allschools), 1)[0]);
    //// console.log("This is the filtered list: -------------------?" + filteredList);
    return filteredList;
  }

  setAgencySelectedValues() {
    if (this.selectAgencyFormControl.value && this.selectAgencyFormControl.value.length > 0) {
      this.selectAgencyFormControl.value.forEach((e) => {
        if (this.selectedAgency.indexOf(e) == -1) {
          this.selectedAgency.push(e);
        }
      });
    }
  }

  setSchoolSelectedValues() {
    if (this.selectSchoolFormControl.value && this.selectSchoolFormControl.value.length > 0) {
      this.selectSchoolFormControl.value.forEach((e) => {
        if (this.selectedSchool.indexOf(e) == -1) {
          this.selectedSchool.push(e);
        }
      });
    }
  }

  selectionAgencyChange(event) {
    console.log("Selection agency change called");
    this.selectedSchool = [];

    this.selectSchoolFormControl.patchValue(this.selectedSchool);

    if (event.isUserInput) {
      if (event.source.selected == true) {
        event.source.value === "All Agencies" ? (this.selectedAgency = this.agenciesList.map((x) => {
          return x.shortCode;
        }))
          : this.selectedAgency.push(event.source.value);
      } else {
        if (event.source.value === "All Agencies") {
          this.selectedAgency = [];
        } else {
          let index = this.selectedAgency.indexOf(event.source.value);
          this.selectedAgency.splice(index, 1);
          let allindex = this.selectedAgency.indexOf("All Agencies");
          this.selectAgencyFormControl.value.includes("All Agencies") ? this.selectedAgency.splice(allindex, 1) : "";
        }
      }
      this.selectAgencyFormControl.patchValue(this.selectedAgency);
      this.onAgencyChangeMultiSelect(event);
    }
  }

  onStudentTypeChange(event: any) {
    this.absenceRosterStudentSelection=event.detail.value;

    console.log('Student Type changed to:', this.absenceRosterStudentSelection);
    console.log('Event Value:', event.detail.value);

    if(this.report.reportName === "Student Enrollment Report"){
      if(this.absenceRosterStudentSelection === "all"){
        this.disableActivities = true;
        this.disableStartEnd = true;
        this.reportForm.removeControl("startDate");
        this.reportForm.removeControl("endDate");
      }
      else{
        this.reportForm.addControl("startDate", new FormControl("", Validators.required));
        this.reportForm.addControl("endDate", new FormControl("", Validators.required));
        this.disableActivities = false;
        this.disableStartEnd = false;
      }
    }
  }

  selectionSchoolChange(event) {
    // this.selectedSchool = [];
    if (event.isUserInput) {
      if (event.source.selected == true && !this.isSchoolsListUpdated) {
        this.isSchoolsListUpdated = true;
        if (event.source.value === "All Schools") {
          this.selectedSchool = this.schoolsList.map((x) => x.schoolName);
        } else {
          if (!this.selectedSchool.includes(event.source.value)) {
            this.selectedSchool = [...this.selectedSchool, event.source.value];
          }
        }
        this.isSchoolsListUpdated = false;
        /*  event.source.value == "All Schools"
          ? (this.selectedSchool = this.schoolsList.map((x) => {
              return x.schoolName;
            }))
          : this.selectedSchool.push(event.source.value);*/
      } else {
        console.log("Line number 240");
        if (event.source.value == "All Schools") {
          this.selectedSchool = [];
        } else {
          console.log("Line number 244");
          let index = this.selectedSchool.indexOf(event.source.value);
          this.selectedSchool.splice(index, 1);
          let allindex = this.selectedSchool.indexOf("All Schools");
          this.selectSchoolFormControl.value.includes("All Schools")
            ? this.selectedSchool.splice(allindex, 1)
            : "";
        }
      }
      this.selectSchoolFormControl.patchValue(this.selectedSchool);
      this.onSchoolChangeMultiSelect(event);
    }
  }

  // fetch reports data
  fetchData() {
    //called when clicking on a specific report
    this.loading = true;
    this.reportService.getReports().subscribe((data: any) => {
      console.log("fetchData(): data from service:", data);
      this.Reports = data;
    });
  }

  // fetch award data by school ID
  fetchAwards(id) {
    this.disableAwards = false;
    this.awardsService.getAwardsBySchoolId(id).subscribe((data: any) => {
      console.log("fetchAwards(): data from agencies service:", data);
      this.awardsList = [];
      data = Array.from(new Set(data.map((a) => a.award.id))).map((id) => {
        return data.find((a) => a.award.id === id);
      });
      data.forEach((element) => {
        const dooType = element.award.dooType === 1 ? "CORE" : "SUPP";
        const type = element.award.type === 1 ? "Before School" : "After School";
        const funder = element.award.fundingSource.funder ? element.award.fundingSource.funder.shortCode : "N/A";
        element.award.text = funder +  " - " + element.award.fundingSource.cohort + " - " + dooType + " - " + type;
        if (element.award.isActive) {
          this.awardsList.push(element.award);
        }
      });
      this.disableAwards = this.awardsList.length > 0 ? false : true;
    });
  }

  // fetch schools data by Agency ID
  fetchSchools(id) {
    this.schoolsList = [];
    this.disableSchools = false;
    console.log("report.reportName ", this.report.reportName);

    // For Role 8, always fetch schools for the user's agency
    if (this.hasRoles([8])) {
      this.schoolsService.getSchoolsByAgency(this.profile.agency).subscribe((data: any) => {
        this.schoolsList = data.sort((a, b) => a.schoolName.localeCompare(b.schoolName));
        this.disableSchools = this.schoolsList.length > 0 ? false : true;
        this.searchSchoolInputTxt.valueChanges.pipe(
          startWith<string>(""),
          map((name) => this._schoolFilter(name))
        ).subscribe((data: any) => {
          this.filteredSchoolOptions2 = data;
        });
      });
      return;
    }

    if (!this.report.reportName.includes("Global Report")) {
      let selectedAgencyIds =
        this.displayMultipleSelection == true
          ? this.agenciesList
            .filter((x) => this.selectAgencyFormControl.value.includes(x.shortCode))
            .map((x) => {
              return x.id;
            })
          : id.toString();

      selectedAgencyIds = this.displayMultipleSelection == true
        ? selectedAgencyIds
          .map((e) => e.toString()
            .replace(/\s/g, ""))
          .join(",")
        : id.toString();


      if (selectedAgencyIds) {
        var scObservable$;
        if (this.displayMCYear())
          scObservable$ = this.schoolsService.getSchoolsByAgencyIdsandByMCC(selectedAgencyIds, this.selectedMCC);
        else {
          scObservable$ = this.schoolsService.getSchoolsByAgencyIds(selectedAgencyIds);
        }
      } else {
        return;
      }

      scObservable$.subscribe((data: any) => {
        this.schoolsList = data.sort((a, b) => a.schoolName.localeCompare(b.schoolName));

        if (this.displayMultipleSchoolSelection && this.reportForm.get("schoolId")) {
          this.reportForm.get("schoolId").setValue(-1);
        }

        this.disableSchools = this.schoolsList.length > 0 ? false : true;

        this.searchSchoolInputTxt.valueChanges.pipe(
          startWith<string>(""),
          map((name) => this._schoolFilter(name))
        ).subscribe((data: any) => {
          this.filteredSchoolOptions2 = data;
        });

      });
    } else {
      this.schoolsService.getSchoolsByAgency(id).subscribe((data: any) => {
        this.schoolsList = data.sort((a, b) => a.schoolName.localeCompare(b.schoolName));
        this.disableSchools = this.schoolsList.length > 0 ? false : true;
      });
    }

    if (!this.displayMultipleSchoolSelection) {
      this.reportForm.get('schoolmultilist').clearValidators();
      this.reportForm.get('schoolmultilist').updateValueAndValidity();
    }
  }

  // fetch schools data
  fetchAllSchools() {
    this.schoolsList = [];
    this.disableSchools = false;
    this.schoolsList = [...this.globalShareService.allSchools];
    this.disableSchools = this.schoolsList.length > 0 ? false : true;
  }

  //fetch schools data by Agency ID and Master Calendar Code
  fetchSchoolsMCC() {
    this.schoolsList = [];
    var currentAgencyId = this.selectedAgencyId == -1 ? this.agencyId : this.selectedAgencyId;
    this.disableSchools = false;
    console.log("currentAgencyId :", currentAgencyId);
    this.schoolsService
      .getSchoolsByAgencyMC(currentAgencyId, this.selectedMCC)
      .subscribe((data: any) => {
        console.log("fetchSchoolsMCC(): data from schools service:", data);
        this.schoolsList = data;
        this.schoolsList.unshift({ id: -1, schoolName: "All Schools" });

        if (this.reportForm.get("schoolId"))
          this.reportForm.get("schoolId").setValue(-1);

        this.selectedSchool = this.schoolsList.map((x) => {
          return x.schoolName;
        });

        this.selectSchoolFormControl.patchValue(this.selectedSchool);

        this.disableSchools = this.schoolsList.length > 0 ? false : true;
        this.filteredSchoolOptions = this.searchSchoolInputTxt.valueChanges.pipe(startWith<string>(""), map((name) => this._schoolFilter(name)));
      });
  }

  fetchEnrichmentCode() {
    this.disableEnrichmentCodes = false;
    this.calendarService.getEnrichmentCodes().subscribe((data: any) => {
      console.log("getEnrichmentCodes(): data :", data);
      this.enrichmentCodesList = data;
      this.disableEnrichmentCodes =
        this.enrichmentCodesList.length > 0 ? false : true;
    });
  }

  // fetch agency data
  fetchAgencyList() {
  const isDailyOrER = this.report && this.report.reportName && (this.report.reportName.includes('Daily Attendance Report') || this.report.reportName.includes('ER Report'));
    
    // For Daily Attendance Report and ER Report, disable agency dropdown if role is not 5
    if (isDailyOrER && !this.hasRoles([5])) {
      this.disableAgency = true;
      this.disableSchools = false;
      let agObservable$: Observable<any> = this.agenciesService.getAgencies();
      agObservable$.subscribe((data: any) => {
        this.agenciesList = data.filter((x) => x.isActive && x.id === this.profile.agency);
        if (this.reportForm.get("agencies")) {
          this.reportForm.get("agencies").patchValue([this.profile.agency]);
          // Fetch schools for the agency immediately
          this.fetchSchools(this.profile.agency);
        }
        this.filteredAgencyOptions = this.searchAgencyInputTxt.valueChanges.pipe(startWith<string>(""), map((name) => this._agencyFilter(name)));
      });
      return;
    }
    
    // For Role 8 and Daily Attendance Report/ER Report, auto-fetch schools for agency after setting agency
    // Only declare isDailyOrER once at the top of the function
    if (isDailyOrER && this.hasRoles([8])) {
      this.disableAgency = true;
      this.disableSchools = false;
      let agObservable$: Observable<any> = this.agenciesService.getAgencies();
      agObservable$.subscribe((data: any) => {
        this.agenciesList = data.filter((x) => x.isActive && x.id === this.profile.agency);
        if (this.reportForm.get("agencies")) {
          this.reportForm.get("agencies").patchValue([this.profile.agency]);
          // Fetch schools for the agency immediately
          this.fetchSchools(this.profile.agency);
        }
        this.filteredAgencyOptions = this.searchAgencyInputTxt.valueChanges.pipe(startWith<string>(""), map((name) => this._agencyFilter(name)));
      });
      return;
    }
    // Default/original logic for all other cases
    if (
      this.hasRoles([5, 6]) &&
      this.report.reportName.includes("Raw Attendance Report") ||
      this.report.reportName.includes("Daily Attendance Backup") ||
      this.report.reportName.includes("Absence Roster") ||
      this.report.reportName.includes("Early Release Forms")
    ) {
      this.displayMultipleSelection = false;
    }
    else {
      this.displayMultipleSelection = true;
    }

    if (this.hasRoles([5, 6]) &&
      (
        this.report.reportName.includes("Offline Attendance") ||
        this.report.reportName.includes("Attendance Summary") ||
        this.report.reportName.includes("Student Enrollment Report") ||
        this.report.reportName.includes("Performance Summary")
      )) {
      this.displayMultipleSchoolSelection = true;
      this.displayMultipleSelection = true;
    }
    else {
      this.displayMultipleSchoolSelection = false;
      this.displayMultipleSelection = false;
    }

    if (!this.displayMultipleSchoolSelection) {
      this.reportForm.get('schoolmultilist').clearValidators();
      this.reportForm.get('schoolmultilist').updateValueAndValidity();
    }

    this.checkFormValidity();

  let agObservable$: Observable<any>;
    if (this.displayMCYear())
      agObservable$ = this.agenciesService.getAgenciesByMCC(this.selectedMCC);
    else
      agObservable$ = this.agenciesService.getAgencies();

    agObservable$.subscribe((data: any) => {
      this.agenciesList = data
        .filter((x) => x.isActive)
        .sort((a, b) => a.name.localeCompare(b.name));

      if (this.report.reportName.includes("Grant Export")) {
        this.agenciesList.unshift({
          id: -1,
          name: "All Agencies",
          shortCode: "All Agencies",
        });

        let agencyEvent = {
          isUserInput: true,
          source: { selected: true, value: "All Agencies" },
        };

        this.selectionAgencyChange(agencyEvent);

        if (this.reportForm.get("agencies"))
          this.reportForm.get("agencies").setValue([-1]);
      }
      else if (
        (
          this.report.reportName.includes("Raw Attendance Report") ||
          this.report.reportName.includes("Offline Attendance") ||
          this.report.reportName.includes("Absence Roster") ||
          this.report.reportName.includes("Early Release Forms") ||
          this.report.reportName.includes("Attendance Summary") ||
          this.report.reportName.includes("Student Enrollment Report") ||
          this.report.reportName.includes("Student Roster Report") ||
          this.report.reportName.includes("Performance Summary")
        ) &&
        this.hasRoles([6, 8])
      ) {
        this.disableAgency = true;
        const agencies = [];
        this.displayMultipleSelection = false;
        agencies.push(this.profile.agency);
        if (this.reportForm.get("agencies"))
          this.reportForm.get("agencies").patchValue(agencies);

        if (
          this.report.reportName.includes("Raw Attendance Report") ||
          this.report.reportName.includes("Offline Attendance") ||
          this.report.reportName.includes('Absence Roster') ||
          this.report.reportName.includes("Performance Summary")
        ) {
          this.fetchSchools(this.profile.agency);
        }
      } else if (
        this.report.reportName.includes("Attendance Summary") ||
        this.report.reportName.includes("Offline Attendance") ||
        this.report.reportName.includes("Student Enrollment Report") ||
        this.report.reportName.includes("Student Roster Report") ||
        this.report.reportName.includes("Performance Summary")
      ) {
        this.agenciesList.unshift({ id: -1, name: "All Agencies", shortCode: "All Agencies", });
        let agencyEvent = {
          isUserInput: true,
          source: { selected: true, value: "All Agencies" },
        };
        this.selectionAgencyChange(agencyEvent);
        if (this.reportForm.get("agencies"))
          this.reportForm.get("agencies").setValue([-1]);
      }
      console.log("this.agenciesList", this.agenciesList);
      this.filteredAgencyOptions = this.searchAgencyInputTxt.valueChanges.pipe(startWith<string>(""), map((name) => this._agencyFilter(name))
      );
    });
  }

  openedAgencyChange(e) {
    this.searchAgencyInputTxt.patchValue("");
    if (e == true) {
      this.searchAgencyTextBox.nativeElement.focus();
    }
    else {
      if (this.reportForm.get('schoolmultilist')) {
        this.filteredSchoolOptions2 = [];
        this.SelectedfilteredSchoolOptions = [];
        this.reportForm.get('schoolmultilist').patchValue('');
      }

      if (this.reportForm.get("activities")) {
        this.reportForm.get("activities").patchValue("");
      }

      if (this.reportForm.get("startDate")) {
        this.reportForm.get("startDate").patchValue("");
      }

      if (this.reportForm.get("endDate")) {
        this.reportForm.get("endDate").patchValue("");
      }

      if (this.hasRoles([8])) {
        this.fetchSchools(this.profile.agency);
      } else {
        if (!this.report.reportName.includes('Absence Roster'))
          this.fetchSchools(this.profile.agency);
      }
    }
  }

  openedSchoolChange(e) {
    this.searchSchoolInputTxt.patchValue("");
    if (e == true) {
      this.searchSchoolTextBox.nativeElement.focus();
    }
  }

  clearAgencySearch(event) {
    event.stopPropagation();
    this.searchAgencyInputTxt.patchValue("");
  }

  clearSchoolSearch(event) {
    event.stopPropagation();
    this.searchSchoolInputTxt.patchValue("");
  }

  // fetch fiscal years data
  fetchFiscalYear() {
    this.reportService.getFiscalYears().subscribe((data: any) => {
      this.fiscalYearList = data.filter((x) => x.isActive);
      console.log("generatereportpopup:fetchFiscalYear(): data from fiscalYear service:", this.fiscalYearList);
      if (this.report.reportName.includes("Projection")) {
        const currentFiscalYear = this.fiscalYearList.find((x) => x.isCurrent);
        this.reportForm.get("fiscalYearId").setValue(currentFiscalYear.id);
        this.reportForm.get("fiscalYearId").disable();
        this.reportForm.get("startDate").disable();
        this.reportForm.get("endDate").disable();
      }
    });
  }

  // fetch master calendars data
  fetchMasterCalendars() {
    this.reportService.getMasterCalendarsForReports().subscribe((data: any) => {
      this.masterCalendarList = data.filter(x => x.isActive);
      console.log('generatereportpopup:fetchFiscalYear(): data from fiscalYear service:', this.fiscalYearList);
      if (this.report.reportName.includes('Projection')) {
        const currentMasterCalendar = this.masterCalendarList.find(x => x.isCurrent);
        this.reportForm.get('masterCalendarId').setValue(currentMasterCalendar.id);
        this.reportForm.get('masterCalendarId').disable();
        this.reportForm.get('startDate').disable();
        this.reportForm.get('endDate').disable();
      }
    });
  }

  // fetch activities list by agency ID
  fetchActivities(schoolId) {
    this.disableActivities = false;
    if (this.displayMultipleSelection) {
      this.selectedSchoolIds = this.schoolsList
        .filter((x) =>
          this.selectSchoolFormControl.value.includes(x.schoolName)
        )
        .map((x) => {
          return x.id;
        });

      this.selectedSchoolIds = this.selectedSchoolIds
        .map((e) => e.toString().replace(/\s/g, ""))
        .join(",");

      this.selectedAgencyIds = this.agenciesList
        .filter((x) => this.selectAgencyFormControl.value.includes(x.shortCode))
        .map((x) => {
          return x.id;
        });

      this.selectedAgencyIds = this.selectedAgencyIds
        .map((e) => e.toString().replace(/\s/g, ""))
        .join(",");

      if (this.selectedSchoolIds.split(",").length > 1 || this.selectedAgencyIds.split(",").length > 1) {
        this.disableActivities = true;
        return;
      }
    }
    else if((this.report.reportName==='Offline Attendance'||
      this.report.reportName==='Attendance Summary'||
      this.report.reportName.includes("Student Enrollment Report") ||
      this.report.reportName.includes("Student Roster Report")  ||
      this.report.reportName.includes("Performance Summary")
      ) && this.hasRoles([6,7])){

      this.selectedSchoolIds = schoolId;
      this.selectedAgencyIds = this.profile.agency;
    }
    else {
      if((this.report.reportName==='Absence Roster' || this.report.reportName==='Offline Attendance'  || this.report.reportName==='Early Release Forms'  ||
        this.report.reportName.includes("Performance Summary")) && this.hasRoles([6,7,8])){
        this.selectedSchoolIds = schoolId;
        this.selectedAgencyId = this.profile.agency;

        console.log("profile. agency id is   ",this.profile.agency)
        console.log("this.agencyid agency id is   ",this.agencyId)
      }else{
        this.selectedSchoolIds = schoolId;
        this.selectedAgencyIds = this.selectedAgencyId;
      }
    }

    console.log("selectedSchoolIds", this.selectedSchoolIds);
    console.log("selectedAgencyIds", this.selectedAgencyIds);

    var agencyId = this.selectedAgencyId;
    var masterCalendarCode = this.selectedMCC;
    if (this.selectedMCC) {
      this.agenciesService.getActivities(this.selectedAgencyIds,this.selectedSchoolIds,masterCalendarCode).subscribe((data: any) => {
          console.log("this.activitiesList", data);
          this.activitiesList = data.map((item) => ({
            activityId: item.scheduledActivity.id,
            activityName: item.activityName + " - " + item.scheduledActivity.groupName,
          }));
        });
    }
  }

  fetchActivitiesForMulti(schoolId) {
    this.disableActivities = false;
    if (this.displayMultipleSelection) {
      this.selectedSchoolIds = schoolId;
      this.selectedAgencyIds = this.agenciesList
        .filter((x) => this.selectAgencyFormControl.value.includes(x.shortCode))
        .map((x) => {
          return x.id;
        });

      this.selectedAgencyIds = this.selectedAgencyIds
        .map((e) => e.toString().replace(/\s/g, ""))
        .join(",");

      if (this.SelectedfilteredSchoolOptions.length > 1 || this.selectedAgencyIds.split(",").length > 1) {
        this.disableActivities = true;
        return;
      }
    }
    else if ((this.report.reportName === 'Offline Attendance' ||
      this.report.reportName === 'Attendance Summary' ||
      this.report.reportName.includes("Student Enrollment Report") ||
      this.report.reportName.includes("Student Roster Report") ||
      this.report.reportName.includes("Performance Summary")
    ) && this.hasRoles([6, 7])) {
      this.selectedSchoolIds = schoolId;
      this.selectedAgencyIds = this.profile.agency;
    }
    else {
      if ((this.report.reportName === 'Absence Roster' || this.report.reportName === 'Offline Attendance' || this.report.reportName === 'Early Release Forms' ||
        this.report.reportName.includes("Performance Summary")) && this.hasRoles([6, 8])) {
        this.selectedSchoolIds = schoolId;
        this.selectedAgencyId = this.profile.agency;

        console.log("profile. agency id is   ", this.profile.agency)
        console.log("this.agencyid agency id is   ", this.agencyId)
      } else {
        this.selectedSchoolIds = schoolId;
        this.selectedAgencyIds = this.selectedAgencyId;
      }
    }

    console.log("selectedSchoolIds", this.selectedSchoolIds);
    console.log("selectedAgencyIds", this.selectedAgencyIds);

    var agencyId = this.selectedAgencyId;
    var masterCalendarCode = this.selectedMCC;
    if (this.selectedMCC) {
      this.agenciesService.getActivities(this.selectedAgencyIds,this.SelectedfilteredSchoolOptions[0].id,masterCalendarCode).subscribe((data: any) => {
          console.log("this.activitiesList", data);
          this.activitiesList = data.map((item) => ({
            activityId: item.scheduledActivity.id,
            activityName: item.activityName + " - " + item.scheduledActivity.groupName,
          }));
        });
    }
  }

  // fetch CY funders data
  fetchFunders() {
    this.fundingService.getFundingCy().subscribe((data: any) => {
      console.log("fetchFunders(): data from funding service:", data);
      data.forEach((x) => {
        x.name = x.fundingSource.funder.name;
        x.id = x.fundingSource.funder.id;
      });
      this.funderList = data.filter(
        (x) =>
          x.fundingSource.funder.name === "ASSETS" ||
          x.fundingSource.funder.name === "ASES" ||
          x.fundingSource.funder.name === "21CCLC"
      );
    });
  }

  // fetch CY data
  fetchCalendarYears() {
    this.reportService.getCalendarYears().subscribe((data: any) => {
      console.log("fetchCalendarYears(): data from fiscalYear service:", data);
      this.calendarYearList = data.filter((x) => x.isActive);
    });
  }

  // sets start and end date range once user inputs fiscal year
  onFYChange(event) {
    this.disableStartEnd = false;
    this.start = null;
    this.end = null;
    this.startMinDate = moment(event[0].data.fromDate).toDate();
    this.startMaxDate = moment(event[0].data.toDate).toDate();
    this.endMinDate = this.startMinDate;
    this.endMaxDate = this.startMaxDate;
    this.start = moment(event[0].data.fromDate).format("MM/DD/YYYY");
    this.end = moment(event[0].data.toDate).format("MM/DD/YYYY");
    this.reportForm.get("startDate").setValue(this.start);
    this.reportForm.get("endDate").setValue(this.end);
  }

  // sets start and end date range once user inputs calendar year
  onCYChange(event) {
    this.disableStartEnd = false;
    this.start = null;
    this.end = null;
    // this.minDate = moment(event[0].data.fromDate).toDate();
    // this.maxDate = moment(event[0].data.toDate).toDate();

    this.startMinDate = moment(event[0].data.fromDate).toDate();
    this.startMaxDate = moment(event[0].data.toDate).toDate();
    this.endMinDate = this.startMinDate;
    this.endMaxDate = this.startMaxDate;

    this.start = moment(event[0].data.fromDate).format("MM/DD/YYYY");
    this.end = moment(event[0].data.toDate).format("MM/DD/YYYY");
    this.reportForm.get("startDate").setValue(this.start);
    this.reportForm.get("endDate").setValue(this.end);
  }

  onMCChange(event) {
    if (this.reportForm.get('schoolmultilist')) {
      this.filteredSchoolOptions2 = [];
      this.SelectedfilteredSchoolOptions = [];;
      this.reportForm.get('schoolmultilist').patchValue('');
    }

    if (this.reportForm.get("activities")) {
      this.reportForm.get("activities").patchValue("");
    }

    if (this.reportForm.get("startDate")) {
      this.reportForm.get("startDate").patchValue("");
    }

    if (this.reportForm.get("endDate")) {
      this.reportForm.get("endDate").patchValue("");
    }

    this.isSelectedMCCChanged = true;
    this.selectedMCC = event[0].data.masterCalendarCode;
    this.disableStartEnd = false;
    this.start = null;
    this.end = null;
    this.startMinDate = moment("01/01/1000").toDate();
    this.startMaxDate = moment().toDate();
    this.endMinDate = this.startMinDate;
    this.endMaxDate = this.startMaxDate;
    this.start = moment(event[0].data.fromDate).format("MM/DD/YYYY");
    this.end = moment(event[0].data.toDate).format("MM/DD/YYYY");

    if (this.reportForm.get("startDate"))
      this.reportForm.get("startDate").setValue(this.start);

    if (!this.report.reportName.includes("Student Enrollment Report")) {
      this.reportForm.get("endDate").setValue(this.end);
    }
    else {
      if (this.hasRoles([8]))
        this.reportForm.get('schoolmultilist').clearValidators();
    }

    const agencyId = document.getElementById("");

    if (this.hasRoles([6, 8])) {
      this.fetchSchools(this.profile.agency);
    } else {
      if (!this.report.reportName.includes('Absence Roster')) {
        this.disableAgency = false;
      }
    }

    this.fetchAgencyList();
  }

  // collects agencies selected
  onAgencyChangeMultiSelect(selectedEvent) {
    let agency = this.agenciesList.filter((x) => x.shortCode === selectedEvent.source.value);
    let event = [{ data: { id: agency[0].id } }];
    const agencies = [];

    event.forEach((element) => {
      agencies.push(element.data.id);
    });

    // if report selected in 'Grant Export', user can only choose 1 agency
    if (this.report.reportName.includes("Grant Export")) {
      if (agencies.includes(-1)) {
        this.multipleAgencies = false;
        this.reportForm.get("agencies").setValue([-1]);
      } else {
        this.multipleAgencies = true;
      }
    }

    if (this.report.reportName.includes("Daily Attendance Backup") ||
      this.report.reportName.includes('Early Release Forms') ||
      this.report.reportName.includes('Absence Roster')) {
      this.multipleAgencies = false;
      this.selectedAgencyId = event[0].data.id;
      this.disableSchools = true;
      if (event.length === 0) {
        this.schoolsList = [];
      }
      if (event.length === 1) {
        this.fetchSchools(event[0].data.id);
      }
      return;
    }

    if (this.displaySchools() && this.hasRoles([5]) && !this.report.reportName.includes("Attendance Summary")) {
      this.disableSchools = true;
      if (event.length === 0) {
        this.schoolsList = [];
      }

      if (event.length === 1) {
        this.fetchSchools(event[0].data.id);
      }

      if (event.length > 1) {
        this.schoolsList.unshift({ id: -1, schoolName: "All Schools" });
        this.reportForm.get("schoolId").setValue(-1);
        this.selectedSchool = this.schoolsList.map((x) => {
          return x.schoolName;
        });
        this.selectSchoolFormControl.patchValue(this.selectedSchool);
        this.disableSchools = true;
      }
    }

    if (this.reportForm.get("agencies"))
      this.reportForm.get("agencies").patchValue(agencies);
    if (
      (this.report.reportName.includes("Attendance Summary") ||
        this.report.reportName.includes("Absence Roster") ||
        this.report.reportName.includes("Student Enrollment Report") ||
        this.report.reportName.includes("Student Roster Report")
      ) &&
      !this.report.reportName.includes("Provider")
    ) {
      this.selectedAgencyId = event[0].data.id;
      if (this.selectedAgencyId == -1 && this.isSelectedMCCChanged == true) {
        this.fetchSchools(this.selectedAgencyId);
        this.isSelectedMCCChanged = false;
      }
    }
  }

  // collects agencies selected
  onAgencyChange(event) {
    if (this.displayStart() && this.reportForm.get("startDate")) {
      this.reportForm.get("startDate").patchValue("");
    }

    if (this.displayEnd() && this.reportForm.get("endDate")) {
      this.reportForm.get("endDate").patchValue("");
    }

    const agencies = [];
    event.forEach((element) => {
      agencies.push(element.data.id);
    });

    // if report selected in 'Grant Export', user can only choose 1 agency
    if (this.report.reportName.includes("Grant Export")) {
      if (agencies.includes(-1)) {
        this.multipleAgencies = false;
        this.reportForm.get("agencies").setValue([-1]);
      } else {
        this.multipleAgencies = true;
      }
    }

    if (this.report.reportName.includes("Daily Attendance Backup") || this.report.reportName.includes('Early Release Forms')) {
      this.multipleAgencies = false;
      this.selectedAgencyId = event[0].data.id;
      this.disableSchools = true;
      if (event.length === 0) {
        this.schoolsList = [];
      }
      if (event.length === 1) {
        this.fetchSchools(event[0].data.id);
      }
      return;
    }

    if (this.displaySchools() && this.hasRoles([5]) && !this.report.reportName.includes("Attendance Summary")) {
      this.disableSchools = true;

      if (event.length === 0) {
        this.schoolsList = [];
      }

      if (event.length === 1) {
        this.fetchSchools(event[0].data.id);
      }

      if (event.length > 1) {
        this.schoolsList.unshift({ id: -1, schoolName: "All Schools" });
        this.reportForm.get("schoolId").setValue(-1);
        this.selectedSchool = this.schoolsList.map((x) => {
          return x.schoolName;
        });
        this.selectSchoolFormControl.patchValue(this.selectedSchool);
        this.disableSchools = true;
      }
    }

    if (this.reportForm.get("agencies"))
      this.reportForm.get("agencies").patchValue(agencies);

    if ((this.report.reportName.includes("Attendance Summary") ||
      this.report.reportName.includes("Absence Roster") ||
      this.report.reportName.includes("Student Enrollment Report") ||
      this.report.reportName.includes("Student Roster Report")) &&
      !this.report.reportName.includes("Provider")
    ) {
      this.selectedAgencyId = event[0].data.id;
    }
  }

  onSchoolChangeMultiSelect(selectedEvent) {
    var name=this.report.reportName;
    let school = this.schoolsList.filter((x) => x.schoolName === selectedEvent.source.value);
    let event = [{ data: { id: school[0].id } }];

    this.enabledDates = this.allDates;
    this.highlightOnlyReportDates = [];
    if (this.displayAwards()) {
      this.disableAwards = true;
      this.fetchAwards(event[0].data.id);
    }
    const requestReport = this.reportForm.value;
    if (this.hasRoles([6, 8])) {
      if (this.agencyId && event[0].data.id) {
        var currentAgencyId = this.selectedAgencyId == -1 ? this.agencyId : this.selectedAgencyId;

        this.reportService
          .getReportDates(currentAgencyId, event[0].data.id,name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    } else {
      if (requestReport.agencies && event[0].data.id) {
        this.reportService
          .getReportDates(requestReport.agencies, event[0].data.id,name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    }
    this.fetchActivities(event[0].data.id);
  }

  onSchoolDropdownCloseMultiSelect(selectedmultiagencyids, selectedmultischoolids) {
    var name = this.report.reportName;
    this.enabledDates = this.allDates;
    this.highlightOnlyReportDates = [];
    const requestReport = this.reportForm.value;

    if (this.hasRoles([6, 8])) {
      if (this.agencyId) {
        var currentAgencyId = this.selectedAgencyId == -1 ? this.agencyId : selectedmultiagencyids;
        if (selectedmultischoolids.length > 0) {
          this.reportService
            .getReportDatesforMulti(currentAgencyId, selectedmultischoolids, name)
            .subscribe((dates) => {
              this.availableDate = dates;
              this.enableReportAvailableDates(this.availableDate);
            });
        }
      }
    } else {
      if (selectedmultiagencyids.length > 0 && selectedmultischoolids.length > 0) {
        this.reportService
          .getReportDatesforMulti(selectedmultiagencyids, selectedmultischoolids, name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    }

    if (this.SelectedfilteredSchoolOptions.length == 1 && this.SelectedfilteredSchoolOptions[0].id != -1)
      this.fetchActivitiesForMulti(this.SelectedfilteredSchoolOptions[0].id);
    else
      this.activitiesList = [];
  }

  onSchoolSelectedChangeMultiSelect(selectedEvent) {
    var name=this.report.reportName;
    let school = this.schoolsList.filter((x) => x.schoolName === selectedEvent);
    let event = [{ data: { id: school[0].id } }];

    this.enabledDates = this.allDates;
    this.highlightOnlyReportDates = [];
    if (this.displayAwards()) {
      this.disableAwards = true;
      this.fetchAwards(event[0].data.id);
    }
    const requestReport = this.reportForm.value;
    if (this.hasRoles([6, 8])) {
      if (this.agencyId && event[0].data.id) {
        var currentAgencyId = this.selectedAgencyId == -1 ? this.agencyId : this.selectedAgencyId;

        this.reportService
          .getReportDates(currentAgencyId, event[0].data.id,name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    } else {
      if (requestReport.agencies && event[0].data.id) {
        this.reportService
          .getReportDates(requestReport.agencies, event[0].data.id,name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    }
    if(this.SelectedfilteredSchoolOptions.length > 1)
    {this.disableActivities = true;}
    else
    this.fetchActivitiesForMulti(event[0].data.id);
  }

  onSchoolChange(event) {
    var name = this.report.reportName;
    this.enabledDates = this.allDates;
    this.highlightOnlyReportDates = [];

    if (this.displayAwards()) {
      this.disableAwards = true;
      this.fetchAwards(event[0].data.id);
    }

    const requestReport = this.reportForm.value;

    if (this.hasRoles([6, 8])) {
      if (this.agencyId && event[0].data.id) {
        var currentAgencyId = this.selectedAgencyId == -1 ? this.agencyId : this.selectedAgencyId;
        this.reportService
          .getReportDates(currentAgencyId, event[0].data.id, name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    } else {
      if (requestReport.agencies && event[0].data.id) {
        this.reportService
          .getReportDates(requestReport.agencies, event[0].data.id, name)
          .subscribe((dates) => {
            this.availableDate = dates;
            this.enableReportAvailableDates(this.availableDate);
          });
      }
    }

    console.log("event[0].data", event[0].data.id);

    this.checkFormValidity();
    this.fetchActivities(event[0].data.id);

    if (requestReport.activities === '') {
      if(this.report.reportName.includes("Student Roster Report")){
        this.disableGenerate = true;
      }
    }
  }

  onActivityChange(event) {
    this.tempActivitiesList = [];
    event.forEach((element) => {
      this.tempActivitiesList.push(element.data.activityId);
    });

    if (this.report.reportName.includes("Student Roster Report")) {
      if (this.tempActivitiesList.length === 0) {
        this.disableGenerate = true;
      }
      else if (this.tempActivitiesList.length > 3) {
        this.disableGenerate = true;
        this.limitScheduledGroups = true;
      }
      else {
        this.disableGenerate = false;
        this.limitScheduledGroups = false;
      }
    }
  }

  enableReportAvailableDates(reportAvailableDate) {
    if (this.report.reportName.includes("Daily Attendance Backup") || this.report.reportName.includes("Early Release Forms")) {
      this.enabledDates = reportAvailableDate.map((f) => Date.parse(f.to_char + " 23:59:59"));
      let reportDates = reportAvailableDate.map((f) => f.to_char + " 23:59:59");
      reportDates.forEach((date) => {
        let highlightedTo = {
          date: new Date(date),
          classes: ["highlight-reportdate"],
        };
        this.highlightOnlyReportDates.push(highlightedTo);
      });
    }
  }

  // fetches user's profile details
  get profile() {
    return this.userProfileStorage.profile;
  }

  highlightReportDate(date, mode) {
    if (mode === "day") {
      var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
      var currentDay = new Date().setHours(0, 0, 0, 0);

      if (dayToCheck === currentDay) {
        return "highlight-date";
      }
    }

    return "";
  }

  // limits user's permissions based on roles
  hasRoles(roles: number[]): boolean {
    if (this.profile) {
      for (const aRole of this.profile.roles) {
        if (roles.includes(aRole)) {
          return true;
        }
      }
    }
    return false;
  }

  displayAnnualOutcome() {
    this.showAnnualOutcome = this.report.reportName.includes("Annual Outcome");
    return this.showAnnualOutcome;
  }

  displayAgency() {
    // Always show Agency for Daily Attendance Report and ER Report
    if (this.report && this.report.reportName && (this.report.reportName.includes('Daily Attendance Report') || this.report.reportName.includes('ER Report'))) {
      this.showAgency = true;
      return true;
    }
    this.showAgency =
      this.report.reportName.includes("Attendance Summary") ||
      this.report.reportName.includes("Student Enrollment Report") ||
      this.report.reportName.includes("Offline Attendance") ||
      this.report.reportName.includes("Performance Summary") ||
      this.report.reportName.includes("Raw Attendance Report") ||
      this.report.reportName.includes('Early Release Forms') ||
      this.report.reportName.includes('Absence Roster') ||
      this.report.reportName.includes('Student Roster Report') ||
      this.report.reportName.includes('Daily Attendance Report') ||
      this.report.reportName.includes('ER Report') ||
      (this.report.reportName.includes("Daily Attendance Backup") &&
          !this.hasRoles([6, 8])) ? true : false;
    return this.showAgency;
  }

  displayFYCYOpt() {
    this.showFYCYOpt =
      (this.report.reportName.includes("Attendance Summary") ||
        this.report.reportName.includes("Student Enrollment Report")) &&
      this.report.reportName.includes("Provider");
    return this.showFYCYOpt;
  }

  displaySchools() {
    // Always show School for Daily Attendance Report and ER Report
    if (this.report && this.report.reportName && (this.report.reportName.includes('Daily Attendance Report') || this.report.reportName.includes('ER Report'))) {
      this.showSchools = true;
      return true;
    }
    this.showSchools =
      ((this.report.reportName.includes('Attendance Summary') && !this.report.reportName.includes('BTB Attendance Summary (by Provider) [report]'))
        || this.report.reportName.includes('Offline Attendance')
        || this.report.reportName.includes('Early Release Forms')
        || this.report.reportName.includes('Absence Roster')
        || this.report.reportName.includes("Student Enrollment Report")
        || this.report.reportName.includes('Performance Summary')
        || this.report.reportName.includes('Raw Attendance Report')
        || this.report.reportName.includes('Student Roster Report')
        || this.report.reportName.includes('Daily Attendance Backup')
        || this.report.reportName.includes('Daily Attendance Report')
        || this.report.reportName.includes('ER Report')) ? true : false;
    return this.showSchools;
  }

  displayActivities() {
    if ((this.report.reportName.includes("Attendance Summary") ||
      this.report.reportName.includes("Student Enrollment Report") ||
      this.report.reportName.includes("Student Roster Report")) &&
      !this.report.reportName.includes("(by Provider)") &&
      !this.report.reportName.includes("Total Daily Attendance Per Site by Enrichment Code")
    ) {
      return true;
    }
    return false;
  }

  doOpen() {
    this.expandFYDP = true;
    console.log("SingleDemoComponent.doOpen");
  }

  doClose() {
    this.expandFYDP = false;
    console.log("SingleDemoComponent.doClose");
  }

  displayYear() {
    if (this.yearOpt === 1) {
      this.showYear = true;
    } else {
      this.showYear = this.report.reportName.includes("Global Report") ? true : false;
    }
    return this.showYear;
  }

  displayMCYear() {
    return (
      (this.report.reportName.includes("Attendance Summary") ||
        this.report.reportName.includes('Absence Roster') ||
        this.report.reportName.includes("Student Enrollment Report") ||
        this.report.reportName.includes("Student Roster Report")) &&
      !this.report.reportName.includes("BTB Attendance Summary (by Provider) [report]"
      )
    );
    //this.showMCYear = this.report.reportName.includes('Attendance Summary') && !this.report.ReportName.includes('Provider') ? true : false;
    //return this.showMCYear;
  }

  displayCYYear() {
    if (this.yearOpt === 2) {
      this.showCYYear = true;
      return this.showCYYear;
    }
    this.showCYYear = this.report.reportName.includes("Progress By Grant Type") ? true : false;
    return this.showCYYear;
  }

  displayAwards() {
    this.showAwards = this.report.reportName.includes("Progress By Grant Type") ? true : false;
    return this.showAwards;
  }

  displayStart() {
    this.showStart = this.report.reportName.includes('Activity') || (this.report.reportName.includes('HS'))
      || this.report.reportName.includes('Dosage') || this.report.reportName.includes('Progress By Grant Type')
      || this.report.reportName.includes('Projection')
      || this.report.reportName.includes('Participation')
      || this.report.reportName.includes('Daily Attendance Backup')
      || this.report.reportName.includes("Student Enrollment Report")
      || this.report.reportName.includes('Early Release Forms')
      || this.report.reportName.includes('Absence Roster')
      || this.report.reportName.includes('Raw Attendance Report')
      || this.report.reportName.includes('Offline Attendance')
      || this.report.reportName.includes('Summary')
      || this.report.reportName.includes('Total Daily Attendance Per Site by Enrichment Code')
      || this.report.reportName.includes('Unduplicated Student Names')
      || this.report.reportName.includes('Daily Attendance Report')
      || this.report.reportName.includes('ER Report') ? true : false;
    // Enable Start/End date for Daily Attendance Report and ER Report
    if (this.report && this.report.reportName && (this.report.reportName.includes('Daily Attendance Report') || this.report.reportName.includes('ER Report'))) {
      this.disableStartEnd = false;
    }
    return this.showStart;
  }

  displayEnd() {
    this.showEnd =
      this.report.reportName.includes("Activity") ||
        this.report.reportName.includes("HS") ||
        this.report.reportName.includes("Dosage") ||
        this.report.reportName.includes("Student Enrollment Report") ||
        this.report.reportName.includes("Progress By Grant Type") ||
        this.report.reportName.includes("Participation") ||
        this.report.reportName.includes("Raw Attendance Report") ||
        this.report.reportName.includes("Offline Attendance") ||
        this.report.reportName.includes("Projection") ||
        this.report.reportName.includes("Summary") ||
        this.report.reportName.includes(
          "Total Daily Attendance Per Site by Enrichment Code"
        ) ||
        this.report.reportName.includes("Unduplicated Student Names")
        ? true
        : false;
    return this.showEnd;
  }

  /**
   * Returns true if all required fields for Daily Attendance Report are selected.
   * Agency, School, and Date must be selected.
   */
  isDailyAttendanceReportReady(): boolean {
    if (
      this.report &&
      this.report.reportName &&
      (this.report.reportName.includes('Daily Attendance Report') || this.report.reportName.includes('ER Report')) &&
      this.reportForm
    ) {
      const agency = this.reportForm.get('agencies') && this.reportForm.get('agencies').value;
      const school = this.reportForm.get('schoolId') && this.reportForm.get('schoolId').value;
      const date = this.reportForm.get('startDate') && this.reportForm.get('startDate').value;
      return !!(agency && agency.length > 0 && school && date);
    }
    return true;
  }

  /**
   * Returns the label for the date field for the current report.
   * For Daily Attendance Report, returns 'Date', otherwise 'Start Date'.
   */
  getDateLabel(): string {
    if (this.report && this.report.reportName && (this.report.reportName.includes('Daily Attendance Report') || this.report.reportName.includes('ER Report'))) {
      return 'Date';
    }
    return 'Start Date';
  }

  displayEnrichmentCodes() {
    this.showEnrichmentCodes = this.report.reportName.includes("Total Daily Attendance Per Site by Enrichment Code") ? true : false;
    return this.showEnrichmentCodes;
  }

  selectionChanged(event) {
    console.log(event);
    event = event.sort((a, b) => (a.value > b.value ? 1 : -1));
  }

  yearOptionChange(event) {
    if (event.detail.value === 1) {
      this.fetchFiscalYear();
      this.yearOpt = 1;
    } else {
      this.fetchCalendarYears();
      this.yearOpt = 2;
    }
  }

  cancelReports() {
    this.modal.dismiss("cancel");
    // this.modal.dismiss({ 'cancel': true });
  }

  downloadS3() {
    this.reportMsg = "";
    const requestReport = this.reportForm.value;
    const pipe = new DatePipe("en-US");
    const startDate = pipe.transform(requestReport.startDate, "yyyy-MM-dd");
    var findReport = this.availableDate.find((a) => a.to_char == startDate);
    if (findReport) {
      let agency = requestReport.agencies;
      let schoolId = requestReport.schoolId;
      if (this.hasRoles([6, 8])) {
        agency = this.agencyId;
      }
      this.reportService
        .getAttendanceReport(agency, requestReport.schoolId, startDate)
        .subscribe((response: any) => {
          window.open(response.download);
        });
    } else {
      this.reportMsg = "No report available for this date";
    }
  }

  changeStartDate(event) {
    if (this.reportForm.get("endDate"))
      if (this.reportForm.get("startDate"))
        this.reportForm.get("endDate").setValue("");

    if (event == "Invalid Date") {
      if (this.reportForm.get("startDate")) {
        this.reportForm.get("startDate").setValue("");
      }
    } else if (event != "") {
      console.log(event);
      let inputDay = new Date(event);

      if (inputDay > this.startMaxDate) {
        if (this.reportForm.get("startDate")) {
          this.reportForm.get("startDate").setValue(this.startMaxDate);
          return;
        }
      }

      if (inputDay < this.startMinDate) {
        if (this.reportForm.get("startDate")) {
          this.reportForm.get("startDate").setValue(this.startMinDate);
          return;
        }
      }

      if (
        this.report.reportName.includes("Raw Attendance") ||
        this.report.reportName.includes("Offline Attendance") ||
        this.report.reportName.includes("Absence Roster") ||
        this.report.reportName.includes("Performance Summary")
      ) {
        this.endMinDate = new Date(event);
        this.endMaxDate = new Date(event);
        this.endMaxDate.setDate(this.endMaxDate.getDate() + 60);

        let today = new Date();
        let tempEndDate = this.endMaxDate <= today ? this.endMaxDate : today;
        this.endMaxDate = tempEndDate;

        this.reportForm.get("endDate").setValue(this.endMaxDate);
      } else if (this.report.reportName.includes("Student Enrollment Report")) {
        this.endMinDate = new Date(event);
        this.endMaxDate = new Date(event);
        this.endMaxDate.setDate(this.endMaxDate.getDate() + 366);
        let today = new Date();
        let tempEndDate = this.endMaxDate <= today ? this.endMaxDate : today;
        this.endMaxDate = tempEndDate;
      }
      else if (this.report.reportName.includes("Performance Summary")) {
        this.endMinDate = new Date(event);
      }

      if (
        this.report.reportName.includes("Attendance Summary") ||
        this.report.reportName.includes("Offline Attendance") ||
        this.report.reportName.includes("Performance Summary")
      ) {if(this.reportForm.get("startDate") && this.reportForm.get("startDate").value !== null && this.reportForm.get("startDate").value !=='')
        {  let stdate = this.reportForm.get("startDate").value;
          this.endMaxDate = new Date(stdate);
          this.endMinDate = new Date(stdate);
           if(this.SelectedfilteredSchoolOptions.length > 10)
              {

                this.endMaxDate.setDate(this.endMaxDate.getDate() + 31);

              }
              else{
                this.endMaxDate.setDate(this.endMaxDate.getDate() + 92);
              }
            }
      }
    }
  }

  changeEndDate(event) {
    let inputDay = new Date(event);
    if (inputDay > this.endMaxDate) {
      this.reportForm.get("endDate").setValue(this.endMaxDate);
      return;
    }
    if (inputDay < this.endMinDate) {
      this.reportForm.get("endDate").setValue(this.endMinDate);
      return;
    }
    console.log(event);
    if (this.report.reportName.includes("Performance Summary")) {
      this.startMaxDate = new Date(event);
    }
  }

  generateERReport() {
    console.log("Erreport generate called")
    this.reportMsg = ''
    const requestReport = this.reportForm.value;
    const pipe = new DatePipe('en-US');
    const startDate = pipe.transform(requestReport.startDate, 'yyyy-MM-dd');
    var findReport = this.availableDate.find((a) => a.to_char == startDate);

    if (findReport) {
      let agency = requestReport.agencies;
      let schoolId = requestReport.schoolId
      if (this.hasRoles([6, 8])) {
        agency = this.agencyId;
      }
      this.reportService.getERFormReport(agency, requestReport.schoolId, startDate).subscribe((response: any) => {
        window.open(response.download);
      });
    } else {
      this.reportMsg = "No report available for this date";
    }

    return;
  }

  generateReports(reportToBuild) {
    console.log("Generate Reports called");

    if (reportToBuild.reportName == 'Daily Attendance Backup' ) {
      // this.generateERReport();
      this.downloadS3();
      return;}
    if (reportToBuild.reportName == 'Early Release Forms') {
      console.log("Early Release Forms report calling")
      this.generateERReport();
      return;}

    console.log("this.displayMultipleSelection", this.displayMultipleSelection);
    console.log("this.report.reportname", this.report.reportName);
    this.reportstatus ="Report can be downloaded once its generated and ready for download.";
    let reporturl = this.reportService.getS3ReportUrl(reportToBuild.id);

    if (reporturl === null || reporturl === undefined || true) {
      const pipe = new DatePipe("en-US");
      this.disableGenerate = true;
      this.generateReportText = "Generating...";
      const requestReport = this.reportForm.value;
      if ((this.report.reportName === "Absence Roster" || this.report.reportName === "Early Release Forms") && (this.hasRoles([6, 8]))) {

        // requestReport.schools = this.displayMultipleSelection
        //   ? this.schoolsList
        //     .filter((x) =>
        //       this.selectSchoolFormControl.value.includes(x.schoolName)
        //     )
        //     .map((x) => {
        //       return x.id;
        //     })
        //   : [this.selectedSchoolIds];

        this.selectedSchoolIds  =

         requestReport.schools = this.displayMultipleSchoolSelection && this.selectedSchoolIds.toString().includes(',')
          ? this.convertStringArrayToIntArray(this.selectedSchoolIds.split(","))
          : [this.selectedSchoolIds];

        requestReport.agencies = this.displayMultipleSelection
          ? this.agenciesList
            .filter((x) =>
              this.selectAgencyFormControl.value.includes(x.shortCode)
            )
            .map((x) => {
              return x.id;
            })
          : this.profile.agency;

        console.log("requestReport.agencie" + requestReport.agencies);
        console.log("requestReport.schools" + requestReport.schools);
      }
      if (
        this.report.reportName === "Performance Summary" ||
        this.report.reportName === "Attendance Summary" ||
        this.report.reportName.includes("Student Enrollment Report")||
        this.report.reportName === "Offline Attendance" ||
        this.report.reportName === "Student Roster Report"
      ) {
        if ((this.report.reportName === "Attendance Summary" || this.report.reportName.includes("Student Enrollment Report") ||

          this.report.reportName === "Offline Attendance"  ||
          this.report.reportName.includes("Performance Summary")) && this.hasRoles([8])) {
          requestReport.schools = this.displayMultipleSchoolSelection  && this.selectedSchoolIds.toString().includes(',')
            ?  this.convertStringArrayToIntArray(this.selectedSchoolIds.split(","))
            : [this.selectedSchoolIds];
          requestReport.agencies = this.displayMultipleSelection
            ? this.agenciesList
              .filter((x) =>
                this.selectAgencyFormControl.value.includes(x.shortCode)
              )
              .map((x) => {
                return x.id;
              })
            : this.profile.agency;

          console.log("requestReport.agencie" + requestReport.agencies);
          console.log("requestReport.schools" + requestReport.schools);
        }
        else{
        requestReport.schools = this.displayMultipleSchoolSelection  && this.selectedSchoolIds.toString().includes(',')
          ?  this.convertStringArrayToIntArray(this.selectedSchoolIds.split(","))
          : [this.selectedSchoolIds];
        requestReport.agencies = this.displayMultipleSelection
          ? this.agenciesList
              .filter((x) =>
                this.selectAgencyFormControl.value.includes(x.shortCode)
              )
              .map((x) => {
                return x.id;
              })
          : this.profile.agency;

        console.log("requestReport.agencie" + requestReport.agencies);
        console.log("requestReport.schools" + requestReport.schools);
      }
      } else {
        if (requestReport.schoolId !== undefined) {
          if (
            requestReport.schoolId === -1 &&
            !this.report.reportName.includes("Attendance Summary") &&
            !this.report.reportName.includes("Raw Attendance Report")
          ) {
            requestReport.schools = [];
          } else {
            requestReport.schools = [requestReport.schoolId];
          }
          delete requestReport.schoolId;
        } else {
          requestReport.schools = [];
        }
        if (requestReport.agencies && requestReport.agencies.length > 0) {
          if (requestReport.agencies.includes(-1)) {
            requestReport.agencies = [];
          }
        }
      }

      requestReport.activities = this.tempActivitiesList;
      if (requestReport.activities === undefined) {
        requestReport.activities = [];
      }
      requestReport.reportId = reportToBuild.id;
      requestReport.category = this.report.category;
      requestReport.reportName = this.report.reportName;
      requestReport.agencies = this.showAgency
        ? requestReport.agencies instanceof Array == true
          ? requestReport.agencies
          : [requestReport.agencies]
        : [environment.agencyId];
      requestReport.fiscalYearId = this.showYear? requestReport.fiscalYearId : null;
      let startDate = null;
      let endDate = null;

      console.log("requestReport.agencie" + requestReport.agencies);
      console.log("requestReport.schools" + requestReport.schools);
      if (requestReport.startDate != null) {
        startDate = pipe.transform(requestReport.startDate, "yyyy-MM-dd");
      }

      if (requestReport.endDate) {
        endDate = pipe.transform(requestReport.endDate, "yyyy-MM-dd");
      }

      this.generatedReportName = reportToBuild.reportName;
      requestReport.startDate = startDate;
      requestReport.endDate = endDate;
      requestReport.studentsType=this.absenceRosterStudentSelection;
      /*`if (moment(requestReport.startDate).isAfter(moment(requestReport.endDate))) {
        this.throwValidationError('Start Date cannot be after End Date');
        this.disableGenerate = false;
        this.generateReportText = 'Generate Report';
      } else {
        this.reportService.generateGlobalReport(requestReport).subscribe((res) => {
          // console.log('Response:', res);
          this.isConfirm = true;
          this.blob = new Blob([res], { type: res.type });
        },
          error => {
            // console.log('Error:', error);
            this.disableGenerate = false;
            this.generateReportText = 'Generate Report';
            this.isConfirm = false;
          });
      }*/

      if (moment(requestReport.startDate).isAfter(moment(requestReport.endDate))) {
        this.throwValidationError("Start Date cannot be after End Date");
        this.disableGenerate = false;
        this.generateReportText = "Generate Report";
      } else {
        console.log("submitReportRequest:", requestReport);
        this.reportService.submitReportRequest(requestReport).subscribe(
          (res) => {
            // console.log('Response:', res);
            // this.isConfirm = true;
            // this.blob = new Blob([res], { type: res.type });
            this.reportService.AddS3ReportUrl(requestReport.reportId, res.reportUrl);
            this.modal.dismiss("submitted");
          },
          (error) => {
            // console.log('Error:', error);
            this.disableGenerate = false;
            this.generateReportText = "Generate Report";
            this.isConfirm = false;
          }
        );
      }
    } else {
      // this.isConfirm = true;
    }
  }

   convertStringArrayToIntArray(stringArray: string[]): number[] {
    return stringArray.map(str => {
      const num = parseInt(str, 10); // Parse as base 10
      if (isNaN(num)) {
        console.error(`Could not convert '${str}' to an integer.`);
        return NaN; // Or handle the error differently (e.g., return a default value, throw an error)
      }
      return num;
    }).filter(num => !isNaN(num)); // filter out NaN values
  }

  async throwValidationError(message: string) {
    const toast = await this.toastController.create({
      color: "danger",
      duration: 2500,
      message: message,
      showCloseButton: true,
      position: "top",
    });
    await toast.present();
  }

  downloadFile(reportId) {
    let reporturl = this.reportService.getS3ReportUrl(reportId);
    console.log("downloadFile for report:", reportId, reporturl);

    let reportName = reporturl.split("/")[4].split(".")[0];
    this.reportService.reportRequestComplete(reportName).subscribe(
      (res) => {
        console.log("downloadReport: Response:", res);
        // this.isConfirm = true;
        // this.blob = new Blob([res], { type: res.type });
        this.modal.dismiss("submitted");
        this.blob = "";
        this.showSuccess();
        this.generatedReportName = "";

        // Open/download file in a new tab
        const newWindow = window.open(reporturl, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          alert('Please allow pop-ups for this website.');
        }
      },
      (error) => {
        console.log("downloadReport : Error:", error);
        this.disableGenerate = true;
        this.generateReportText = "Generating ...";
        // this.isConfirm = true;
        this.reportstatus = "Report generation is in progress.... Please try later or contact support team.";
      }
    );
    // saveAs(this.blob, this.generatedReportName + '.xlsx');
  }

  confirmationBox() {
    // this.isConfirm = true;
  }

  async showSuccess() {
    const toast = await this.toastController.create({
      color: "success",
      duration: 2500,
      message: "Success!",
      showCloseButton: true,
      position: "top",
    });
    await toast.present();
  }

  async showError(error) {
    const toast = await this.toastController.create({
      color: "danger",
      duration: 2500,
      message: "Error!",
      showCloseButton: true,
      position: "top",
    });
    await toast.present();
  }

  isSelected(selectedAgencyOption: any): boolean {
    console.log(selectedAgencyOption);
    return this.selectedAgency.some(
      (agency) => agency.id === selectedAgencyOption.id
    );
  }

  onAgencyCheckboxChange(event: Event, onAgencyChange: any): void {
    const checkedAgency = event.target as HTMLInputElement;
    if (checkedAgency.checked) {
      if (!this.isSelected(onAgencyChange)) {
        this.selectedAgency.push(onAgencyChange);
      }
    } else {
      this.selectedAgency = this.selectedAgency.filter((agency) => agency.id !== onAgencyChange.id);
    }
    console.log(this.selectedAgency);
  }

  ngOnInit() {
    // setting and support i18n
    this.settings = {
      singleSelection: false,
      idField: 'id',
      textField: 'schoolName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Schools found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    //this.reportForm.addControl(this.newControlName, new FormControl(this.filteredSchoolOptions, Validators.required));
    //this.setForm();

    this.reportstatus = "Report can be downloaded once its generated and ready for download.";
    let reporturl = this.reportService.getS3ReportUrl(this.report.id);
    console.log("generateReports(): ", this.report.id, reporturl);

    if (reporturl === null || reporturl === undefined) {
      this.fetchData();
      this.reportForm.statusChanges.subscribe((change) => {
        if (this.reportForm.dirty) {
          this.modal.backdropDismiss = false;
        }
      });

      this.agencyId = this.profile.agency;

      if (this.displayAnnualOutcome()) {
        this.reportForm.addControl("funderId", new FormControl("", Validators.required));
        this.reportForm.get("agencies").setValue([this.agencyId]);
        this.reportForm.get("fiscalYearId").setValue(null);
        this.reportForm.removeControl("startDate");
        this.reportForm.removeControl("endDate");
        this.fetchFunders();
      }
      if (
        this.report.reportName.includes("Raw Attendance") ||
        this.report.reportName.includes("Offline Attendance")||
        this.report.reportName.includes("Performance Summary")||
        this.report.reportName.includes("Student Enrollment Report")||
        this.report.reportName.includes("Absence Roster") ||
        this.report.reportName.includes("Student Roster Report")
      ) {
        this.disableStartEnd = false;
      };
      // if (this.report.reportName.includes("Performance Summary")) {
      //   this.reportForm.get("agencies").setValue([-1]);
      // }
      if (this.report.reportName.includes("Projection")) {
        if (this.agencyId === null) {
          this.reportForm.removeControl("agencies");
        } else {
          this.reportForm.get("agencies").setValue([this.agencyId]);
        }
      }
      if (this.report.reportName.includes("Activity")) {
        this.disableStartEnd = false;
        if (this.agencyId) {
          this.reportForm.get("agencies").setValue([this.agencyId]);
        } else {
          this.reportForm.removeControl("agencies");
        }
      }
      if (this.report.reportName.includes("Global Report")) {
        this.reportForm.get("fiscalYearId").setValue(null);
        this.reportForm.removeControl("agencies");
        this.reportForm.removeControl("startDate");
        this.reportForm.removeControl("endDate");
      }
      if (this.report.reportName.includes("Progress By Grant Type")) {
        this.disableAwards = true;
        this.reportForm.removeControl("agencies");
        if (this.hasRoles([6, 7])) {
          this.fetchSchools(this.agencyId);
        } else {
          this.fetchAllSchools();
        }
      }
      if (this.report.reportName.includes("Total Daily Attendance Per Site by Enrichment Code")) {
        this.reportForm.removeControl("agencies");
        this.disableEnrichmentCodes = true;
        this.fetchEnrichmentCode();
      }
      if (this.displayAwards()) {
        this.reportForm.addControl("awardId", new FormControl("", Validators.required));
      }
      if (this.hasRoles([6, 7])) {
        if (
          !this.report.reportName.includes("Global Report") &&
          !this.report.reportName.includes("Progress By Grant Type") &&
          !this.report.reportName.includes("Total Daily Attendance Per Site by Enrichment Code")
        ) {
          this.reportForm.get("agencies").setValue([this.agencyId]);
        }
      }

      if (this.displayAgency()) {
        //this.fetchAgencyList();
        if (this.report.reportName.includes("Attendance Summary") ||
          this.report.reportName.includes("Student Enrollment Report") ||
          this.report.reportName.includes("Absence Roster") ||
          this.report.reportName.includes("Student Roster Report")) {
          this.fetchMasterCalendars();
        }
        else {
          this.fetchAgencyList();
        }
        if (this.report.reportName.includes("Participation") ||
          (this.report.reportName.includes("Attendance Summary") || this.report.reportName.includes("Student Enrollment Report") &&
            this.report.reportName.includes("Provider"))
        ) {
          this.multipleAgencies = true;
          console.log("multipleAgencies :", this.multipleAgencies);
        }
      }
      if (this.displaySchools()) {
        if (this.hasRoles([6, 7])) {
          this.fetchSchools(this.agencyId);
        }
        this.reportForm.addControl("schoolId", new FormControl("", Validators.required));
      }
      if (this.displayEnrichmentCodes()) {
        this.reportForm.addControl("enrichmentCode", new FormControl("", Validators.required));
      }
      if (this.displayActivities()) {
        this.reportForm.addControl("activities", new FormControl(""));
      }
      if (this.displaySchools() && !this.hasRoles([6, 7])) {
        if (!this.report.reportName.includes("Attendance Summary") &&
            !this.report.reportName.includes("Student Enrollment Report") &&
            !this.report.reportName.includes("Student Roster Report")) {
          this.disableSchools = true;
        }
      }
      if (this.displayAwards()) {
        this.reportForm.addControl("awardId", new FormControl("", Validators.required));
        this.disableAwards = true;
      }
      if (this.displayYear()) {
        this.fetchFiscalYear();
      }
      if (this.displayCYYear()) {
        this.reportForm.removeControl("fiscalYearId");
        this.reportForm.addControl("calendarYearId", new FormControl("", Validators.required));
        this.fetchCalendarYears();
      }
      if (this.report.reportName.includes('Daily Attendance Backup') || this.report.reportName.includes('Early Release Forms')) {
        const start = new Date(2021, 8, 19)
        const end = moment(new Date()).add(-1, 'd').toDate();
        this.disableStartEnd = false;
        // this.minDate = start;
        // this.maxDate = end;

        this.startMinDate = start;
        this.startMaxDate = end;
        this.endMinDate = start;
        this.endMaxDate = end;

        let startDate = this.startMinDate;
        this.allDates.push(this.startMinDate);

        while (startDate <= this.startMaxDate) {
          var nextDate = startDate.setDate(startDate.getDate() + 1);
          this.allDates.push(nextDate);
          startDate = new Date(nextDate);
        }

        if (this.hasRoles([6, 8])) this.reportForm.removeControl("agencies");
        this.reportForm.removeControl("endDate");
        this.reportForm.removeControl("fiscalYearId");
        if (this.hasRoles([6, 8])) {
          this.hideAgency = false;
          this.fetchSchools(this.agencyId);
        }
      }
      if (this.report.reportName.includes("Performance Summary")) {
        this.startMaxDate = new Date();
        this.endMaxDate = new Date();
        /*const start = new Date(2021,8,19)
        const end = moment(new Date()).add(-1,'d').toDate();
        this.disableStartEnd = false;
        // this.minDate = start;
        // this.maxDate = end;

        this.startMinDate = start;
        this.startMaxDate = end;
        this.endMinDate = start;
        this.endMaxDate = end;

        let startDate = this.startMinDate;
        this.allDates.push(this.startMinDate);

        while(startDate <= this.startMaxDate){
          var nextDate = startDate.setDate(startDate.getDate() + 1);
          this.allDates.push(nextDate);
          startDate = new Date(nextDate);
        }*/
      }
    } else {
      // this.isConfirm = true;
      // this.reportstatus = "Report can be downloaded once its generated and ready for download.";
    }
  }

  public setForm() {
    this.reportForm.addControl(this.newControlName, new FormControl(this.filteredSchoolOptions2, Validators.required));
    this.loadContent = true;
  }

  get f() {
    return this.reportForm.controls;
  }

  public onFilterChange(item: any) {
    console.log(this.SelectedfilteredSchoolOptions);
  }

  public onDropDownClose(items: any) {


    if (this.dropDownSelect) {
      if (this.reportForm.get("activities")) {
        this.reportForm.get("activities").patchValue("");
      }

      if (this.reportForm.get("startDate")) {
        this.reportForm.get("startDate").patchValue("");
      }

      if (this.reportForm.get("endDate")) {
        this.reportForm.get("endDate").patchValue("");
      }

      this.selectedAgencyIds = this.displayMultipleSelection ?
        this.agenciesList
          .filter((x) => this.selectAgencyFormControl.value.includes(x.shortCode))
          .map((x) => {
            return x.id;
          }) : this.profile.agency.toString();

      this.selectedAgencyIds = this.displayMultipleSelection ? this.selectedAgencyIds
        .map((e) => e.toString().replace(/\s/g, ""))
        .join(",") : this.selectedAgencyIds;

      this.selectedSchoolIds = this.SelectedfilteredSchoolOptions.map((x) => {
        return x.id;
      });
      this.selectedSchoolIds = this.selectedSchoolIds
        .map((e) => e.toString().replace(/\s/g, ""))
        .join(",");

      this.onSchoolDropdownCloseMultiSelect(this.selectedAgencyIds, this.selectedSchoolIds);
      this.dropDownSelect = false;
    }
  }

  public onItemSelect(item: any) {
    this.SelectedfilteredSchoolOptions.push(item);
    console.log(this.SelectedfilteredSchoolOptions);
    this.reportForm.get("schoolId").setValue(item.id);
  }

  public onDeSelect(item: any) {
    this.SelectedfilteredSchoolOptions = this.SelectedfilteredSchoolOptions.filter((x) => x.id !== item.id);
    console.log(this.SelectedfilteredSchoolOptions);
    if(this.SelectedfilteredSchoolOptions.length == 0)
    this.reportForm.get("schoolId").setValue('');
    this.activitiesList  = [];

  }

  public onSelectAll(items: any) {
    this.SelectedfilteredSchoolOptions = [];
    this.SelectedfilteredSchoolOptions = items;
    console.log(this.SelectedfilteredSchoolOptions);
    this.reportForm.get("schoolId").setValue(-1);

  }
  public onDeSelectAll(items: any) {
    this.SelectedfilteredSchoolOptions = [];
    console.log(this.SelectedfilteredSchoolOptions);
    this.reportForm.get("schoolId").setValue('');
  }

  checkFormValidity(): void {
    if (this.reportForm.invalid) {
      Object.keys(this.reportForm.controls).forEach((controlName) => {
        const control = this.reportForm.get(controlName);
        if (control.invalid) {
          console.log("Control '${controlName}' is invalid.");
          if (control.errors) {
            Object.keys(control.errors).forEach((errorKey) => {
              console.log("  - ${errorKey}: ${control.errors.[errorKey]}");
            });
          }
        }
      });
    } else {
      console.log("Form is valid");
    }
  }
}
